var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 737,
    viewBox: "0 0 525 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.5 1C359.449 1 524 165.551 524 368.5C524 571.449 359.449 736 156.5 736C-46.4486 736 -211 571.449 -211 368.5C-211 165.551 -46.4486 1 156.5 1Z",
    stroke: "#FFEF00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.283 558.814C375.534 558.814 494.932 440.049 494.932 294.549C494.932 149.049 375.534 30.0677 229.283 30.0677C83.0318 30.0677 -36.5938 148.832 -36.5938 294.56C-36.5938 440.287 82.7926 558.825 229.283 558.825V558.814Z",
    stroke: "#00A8E1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5119 706.932C231.21 706.932 350.972 588.168 350.972 442.667C350.972 297.167 231.221 178.175 84.5119 178.175C-62.1972 178.175 -181.938 296.951 -181.938 442.667C-181.938 588.384 -62.4154 706.932 84.5228 706.932H84.5119Z",
    stroke: "#FF5C00",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLines);
export default __webpack_public_path__ + "static/media/callLines.a1a66ef0f58032fba8214ff614ddb995.svg";
export { ForwardRef as ReactComponent };